import { VenueAttributes } from '@/types'
import { UpdateVenueMutation } from './__generated__/update_mutation'
import { Mutation as UpdateMutation } from './update_mutation'
import { Query as EditQuery } from './edit_query'
import { EditVenueQuery } from './__generated__/edit_query'
import { useForm } from '@/helpers/useForm'
import { Inline as Error } from '@/components/error'
import { Inline as Loading } from '@/components/loading'
import { Query as TableQuery } from './table_query'

type Venue = EditVenueQuery['venues']['nodes'][0]

interface Props {
  id: string
}

export const Form = ({ id }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    queryError,
    queryLoading,
    mutationLoading
  } = useForm<UpdateVenueMutation, VenueAttributes, EditVenueQuery, Venue>({
    id,
    initializer: venue => ({
      name: venue.name,
      address1: venue.address1,
      address2: venue.address2,
      address3: venue.address3,
      city: venue.city,
      county: venue.county,
      postcode: venue.postcode,
      notes: venue.notes,
    }),
    query: EditQuery,
    queryKey: 'venues',
    mutation: UpdateMutation,
    resultKey: 'updateVenue',
    refetchQueries: [TableQuery]
  })

  if (queryLoading) return <Loading />

  return (
    <>
      { queryError && <Error message={queryError} /> }
      <div className="flex flex-col gap-6">
        { formBuilder.buildQueryError() }
        { formBuilder.buildField({ name: 'Name', field: 'name', type: 'text' }) }
        <div className="grid grid-cols-3 gap-6">
          { formBuilder.buildField({ name: 'Address Line 1', field: 'address1', type: 'text' }) }
          { formBuilder.buildField({ name: 'Address Line 2', field: 'address2', type: 'text' }) }
          { formBuilder.buildField({ name: 'Address Line 3', field: 'address3', type: 'text' }) }
          { formBuilder.buildField({ name: 'City', field: 'city', type: 'text' }) }
          { formBuilder.buildField({ name: 'County', field: 'county', type: 'text' }) }
          { formBuilder.buildField({ name: 'Postcode', field: 'postcode', type: 'text' }) }
        </div>
        { formBuilder.buildField({ name: 'Notes', field: 'notes', type: 'textarea' }) }

        { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
      </div>
    </>
  )
}
